import { createSlice } from '@reduxjs/toolkit';
import { getAllTablesAction } from 'redux/actions/table';

const initialState = {
  tablesLoading: false,
  tables: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
export const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllTablesAction.pending]: (state) => {
      state.loading = true;
    },
    [getAllTablesAction.fulfilled]: (state, action) => {
      state.tables = action.payload;
      state.loading = false;
    },
    [getAllTablesAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const actions = tableSlice.actions;
// export the reducer to be passed to configureStore
export default tableSlice.reducer;
